const LoginFailed = () => {
    return <div>
                <h1>
                    404 - Login Failed
                </h1>
                <div>
                    Leider hat es ein Problem beim Login gegeben.
                </div>
            </div>;
};

export default LoginFailed;
